import {UI} from "../../../stem-core/ui/UIBase";

import {BasePanelPage} from "../PanelPage.jsx";
import {AuthFlowPanel} from "../../common/auth/AuthFlowPanel.jsx";


export class AuthPanelPage extends BasePanelPage {
    getFlowOptions() {}

    render() {
        return <AuthFlowPanel {...this.getFlowOptions()} />
    }
}
